import { useEffect, useState } from 'react';

const useReducedMotion = <T>(regularGif: T, reducedMotionGif: T): T => {
  const [gifImage, setGifImage] = useState(reducedMotionGif);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mediaQuery.matches && gifImage !== reducedMotionGif) {
        setGifImage(reducedMotionGif);
      } else if (!mediaQuery.matches && gifImage !== regularGif) {
        setGifImage(regularGif);
      }
    }
  }, [gifImage, setGifImage]);
  return gifImage;
};
export default useReducedMotion;
